import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=197cd56a&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cd56a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197cd56a')) {
      api.createRecord('197cd56a', component.options)
    } else {
      api.reload('197cd56a', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=197cd56a&scoped=true&", function () {
      api.rerender('197cd56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M9bl5iNKbb38/JS/comp/Voucher-Unit.vue"
export default component.exports